module.exports = __webpack_public_path__ + "img/2.f8906350.png";